import React, { useState, useEffect } from 'react';
import { CustomColorMonthItem } from '../../functions/date/colorofTask/colorTask'; // Adapter selon ton code
import { CustomModalWeek } from './customModal';
import { guid } from '@progress/kendo-react-common';
import { sampleDate } from "../../Mock/dataPlanningMock"; // Adapter en fonction des données mock
import { DatePicker } from '@progress/kendo-react-dateinputs';
import { IntlProvider, LocalizationProvider } from '@progress/kendo-react-intl';
import { formatDate, getFirstDayOfMonth, getLastDayOfMonth, sortTasksByTime } from '../../functions/date/getFirstLastDay'; // Tu peux créer ces fonctions
import { useConf } from '../../context/account/paramsAccount';
import { useError } from '../../context/erreur/erreurContext';
import { hookApi } from '../../hook/presta/affichePrestaHook'; // Adapter en fonction des appels API
import { Link } from 'react-router-dom';
import { apiPostWToken } from '../../api/apiPost';
import { MultiColumnComboBox } from "@progress/kendo-react-dropdowns";

const columns = [
    { field: "soc_nom", header: "Nom de la société", width: "30%" },
    { field: "sit_nom", header: "Nom site", width: "30%" },
];

const MonthAgenda = () => {
    const { conf, setConf }: any = useConf();
    const { showError } = useError();
    const [dateData, setDateData]: any = useState([]);
    const [currentDate, setCurrentDate] = useState(new Date());
    const [selectedDate, setSelectedDate] = useState(currentDate);
    const [startOfMonth, setStartOfMonth] = useState(selectedDate.toISOString().split('T')[0]);
    const [endOfMonth, setEndOfMonth] = useState(selectedDate.toISOString().split('T')[0]);
    const [tasks, setTasks]: any = useState({});
    const [selectedTask, setSelectedTask] = useState<any | null>(null);
    const [newDate, setNewDate]: any = useState(null);
    const daysOfWeek = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'];
    interface Site {
        sit_couleur: null
        sit_id: number
        sit_nom: string
        soc_id: number
        soc_nom: string
        v_ordre: string
    }

    const [site, setSite] = useState<Site | null>(null);
    const [dataTab, setDataTab] = useState([])
    const allSitesOption = { sit_nom: "Tous les sites", soc_id: null, soc_nom: "Tous les sites", sit_id: null };
    const fullDataTab = [allSitesOption, ...dataTab];

    useEffect(() => {
        if (conf?.user?.site?.soc_id) {
            setSite(conf.user.site);
        }
    }, [conf?.user?.site?.soc_id]);
    useEffect(() => {
        const data = null
        if (conf.token !== '' && conf.token !== undefined) {
            apiPostWToken("/posts/choix-site", data, conf.token, conf, setConf, showError).then((response: any) => {
                setDataTab(response)
            })
        }
    }, [conf.token])

    useEffect(() => {
        if (!conf.token || !site) return;
        const updateDates = () => {
            const startOfMonth = getFirstDayOfMonth(selectedDate);
            const endMonth = getLastDayOfMonth(selectedDate);
            setEndOfMonth(endMonth.split('T')[0]);
            setStartOfMonth(startOfMonth.split('T')[0]);

            const dateData = { e_date_deb: startOfMonth, e_date_fin: endMonth, e_soc_id: site?.soc_id, url: conf.user.url };
            hookApi('/posts/planning', dateData, conf, setConf, setNewDate, showError);

        };
        // Mise à jour initiale
        updateDates();
        // Répéter toutes les 2 secondes
        const intervalId = setInterval(updateDates, 180000);
        // Nettoyer l'intervalle quand le composant est démonté ou selectedDate/conf.token change
        return () => clearInterval(intervalId);

    }, [selectedDate, conf.token, site]); // Dépendances

    useEffect(() => {
        if (newDate !== null) {
            const startOfMonth = getFirstDayOfMonth(selectedDate);
            const endOfMonth = getLastDayOfMonth(selectedDate);

            // Calcul de la première date à afficher (lundi précédent si besoin)
            const firstDayOfWeek = new Date(startOfMonth);
            const startDay = firstDayOfWeek.getDay(); // 0 (dimanche) à 6 (samedi)
            const diffToMonday = (startDay === 0 ? -6 : (1 - startDay));
            firstDayOfWeek.setDate(firstDayOfWeek.getDate() + diffToMonday);


            // Calcul de la dernière date à afficher (dimanche suivant si besoin)
            const lastDayOfWeek = new Date(endOfMonth);
            const endDay = lastDayOfWeek.getDay(); // 0 (dimanche) à 6 (samedi)
            const diffToSunday = 7 - (endDay === 0 ? 7 : endDay); // Calculer pour obtenir le dimanche suivant
            lastDayOfWeek.setDate(lastDayOfWeek.getDate() + diffToSunday);

            const monthDates = [];
            let currentDate = new Date(firstDayOfWeek);

            // Génération des dates entre le début ajusté et la fin ajustée
            while (currentDate <= lastDayOfWeek) {
                monthDates.push(formatDate(new Date(currentDate)));
                currentDate.setDate(currentDate.getDate() + 1);
            }

            const processedData = newDate;

            if (processedData) {
                setDateData(processedData);
                const datet = sampleDate(processedData);
                const sortedTasks: any = monthDates?.reduce((acc, date) => {
                    acc[date] = sortTasksByTime(datet?.filter((task: any) => formatDate(new Date(task.start)) === date));
                    return acc;

                }, {} as any);

                setTasks(sortedTasks);
            }
        }
    }, [newDate]);
    const handleTaskClick = (task: any) => {
        setSelectedTask(task);
    };

    const handleCloseModal = () => {
        setSelectedTask(null);
    };


    function changeDate(value: Date) {
        const date = new Date(value);

        if (!isValidDate(date)) {
            // La date est invalide => on peut afficher une erreur ou juste ne rien faire
            console.error("Date invalide :", value);
            return;
        }

        setSelectedDate(date);
        const startOfMonth = getFirstDayOfMonth(value);
        const endMonth = getLastDayOfMonth(value);
        setEndOfMonth(endMonth.split('T')[0]);
        setStartOfMonth(startOfMonth.split('T')[0]);
    }
    function isValidDate(d: Date) {
        return d instanceof Date && !isNaN(d.getTime());
    }
    return (
        <div>
            <div className='containerDatePicker'>

                <div className='datePicker'>
                    <div>
                        <MultiColumnComboBox
                            data={fullDataTab}
                            columns={columns}
                            textField={"sit_nom"}
                            placeholder={conf?.user?.site?.sit_nom ? conf.user?.site?.sit_nom : "Selectionnez une valeur"}
                            onChange={(e: any) => { setSite(e.value) }} />
                    </div>
                    <LocalizationProvider language="fr-FR">
                        <IntlProvider locale="fr">
                            <DatePicker defaultValue={selectedDate} onChange={(e: any) => { changeDate(e.target.value) }} />
                        </IntlProvider>
                    </LocalizationProvider>

                </div>
                <div className='weekLink'>
                    <Link className='buttonChangeCalendarMonth ' to='/planning/semaine'>Semaine</Link>
                    <Link className='buttonChangeCalendarMonth semaine' to='/planning'>Mois</Link>
                    <Link className='buttonChangeCalendarMonth' to='/planning/jour'>Jour</Link>
                </div>
            </div>
            <div className="daysOfWeekHeader">
                {daysOfWeek.map(day => (
                    <div key={day} className="dayHeader">{day}</div>
                ))}
            </div>
            <div className='weekContainer'>
                {Object.keys(tasks).map((date, index) => {
                    const currentYear = new Date().getFullYear();
                    const fullDateStr = date.length === 5 ? `${date}` : date;
                    const dayOfWeekIndex = index % 7;
                    const shortDay = daysOfWeek[dayOfWeekIndex];
                    const formattedShortDate = `${shortDay}. ${date}`;
                    return (
                        <div key={guid()} className='weekDate'>
                            <h2 className="dateHeader" data-full-date={fullDateStr} data-short-date={formattedShortDate}>
                            </h2>
                            <div className="weekGrid">
                                <ul className='ulMonth'>

                                    {(tasks[date] || []).map((task: any) => {
                                        if (!task) return null;
                                        const { pastilleColor } = CustomColorMonthItem(task);
                                        return (
                                            <li key={task.id} className='task' onClick={() => handleTaskClick(task)}>
                                                <div className='headerTask'>
                                                    <span style={{ color: 'rgb(150, 189, 13)', fontWeight: 'bold' }}>
                                                        {new Date(task.start).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}
                                                    </span>
                                                    <span>{task.v_num_piece}</span>
                                                </div>
                                                <div className='bodyTask'>
                                                    <span style={{ color: 'blue', fontWeight: 'bold' }}>
                                                        {task.v_desc}
                                                    </span>
                                                    <span style={{ color: 'purple', fontWeight: 'italic' }}>
                                                        {task.v_lib_avancement}
                                                    </span>
                                                    <span style={{ color: 'black', fontWeight: 'bold' }}>
                                                        {task.v_cli_civ_nom}
                                                    </span>
                                                    <span style={{ color: 'red', fontWeight: '900' }}>
                                                        {task.modeVente}
                                                    </span>
                                                    <span className="pastilleweek" style={{ backgroundColor: pastilleColor }}></span>
                                                </div>
                                                <div className='footerTask'>
                                                    <span>{task.v_lieu_civ_nom}</span>
                                                    {task.v_nbre_convive === null ? "" : <span>{task.v_nbre_convive} personnes</span>}
                                                </div>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>
                        </div>
                    )
                })}
            </div>
            {selectedTask && (
                <>
                    <div className="overlay" ></div>
                    <div className="modalDC" onClick={handleCloseModal}  >
                        <div className="titleContainer">
                            <div className='backgroundDC '>
                                <CustomModalWeek dataItem={selectedTask} onClose={handleCloseModal} />
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default MonthAgenda;
